
























































































































































































































































































































import Vue from "vue";
import { onBeforeMount, ref, computed } from "@vue/composition-api";
import _ from "lodash";
import { smartSendingOptions } from "../../helpers/consts";
import { APP_NAME } from "../../helpers/configuration";
import appBridge from "../../helpers/appBridge";

export default Vue.extend({
  name: "Settings",
  setup(props, context: any): any {
    const settings: any = ref({
      smsSenderId: "",
      autoTopupSettings: {
        autoTopupEnabled: false,
        autoTopupAmount: { currencyCode: "USD", units: "0", nanos: 0 },
        autoTopupThreshold: { currencyCode: "USD", units: "0", nanos: 0 },
        autoTopupBudget: { currencyCode: "USD", units: "0", nanos: 0 },
      },
      smartSendingDuration: "600s",
    });

    const previousSettings: any = ref({
      smsSenderId: "",
      autoTopupSettings: {
        autoTopupEnabled: false,
        autoTopupAmount: { currencyCode: "USD", units: "0", nanos: 0 },
        autoTopupThreshold: { currencyCode: "USD", units: "0", nanos: 0 },
        autoTopupBudget: { currencyCode: "USD", units: "0", nanos: 0 },
      },
      smartSendingDuration: "600s",
    });

    const formValid = ref(true);
    const startTime = ref("");
    const endTime = ref("");
    const valid = ref("");

    function getTimeOfDay(hour, minute, amPm) {
      return ((hour == 12 ? 0 : hour) + (amPm == "pm" ? 12 : 0)) * 60 + minute;
    }
    function getNonQuietDuration(minuteStart, minuteEnd) {
      if (minuteStart > minuteEnd) {
        const midnight = 24 * 60;
        return midnight - minuteStart + minuteEnd;
      } else {
        return minuteEnd - minuteStart;
      }
    }
    function convertTime(time) {
      const timeHours = time.split(":");
      let hours = timeHours[0];
      const AmOrPm = hours >= 12 ? "pm" : "am";
      hours = hours % 12 || 12;
      const minutes = timeHours[1];
      return { hours, minutes: parseInt(minutes), AmOrPm };
    }

    function validateQuietHours() {
      const startTimeConverted = convertTime(startTime.value);
      const endTimeConverted = convertTime(endTime.value);
      const minuteStart = getTimeOfDay(
        startTimeConverted.hours,
        startTimeConverted.minutes,
        startTimeConverted.AmOrPm
      );
      const minuteEnd = getTimeOfDay(
        endTimeConverted.hours,
        endTimeConverted.minutes,
        endTimeConverted.AmOrPm
      );
      const valid =
        getNonQuietDuration(minuteStart, minuteEnd) >= 7 * 60 &&
        startTimeConverted.AmOrPm === "pm" &&
        endTimeConverted.AmOrPm === "am";

      return {
        quietHoursValid: valid || "Invalid Quiet Hours",
        startTimeValid: startTimeConverted.AmOrPm === "pm" || "Time must be PM",
        endTimeValid: endTimeConverted.AmOrPm === "am" || "Time must be AM",
      };
    }

    const rules = {
      required: (value) => !!value || "Required",
      autoTopupAmount: (value) => value < 100000 && value > 9,
      autoTopupBudget: (value) => value < 100000 && value > 9,
      autoTopupThreshold: (value) => value < 10000 && value > 1,
      senderId: (value) =>
        /^(?=.*[a-zA-Z])(?=.*[a-zA-Z0-9])([a-zA-Z0-9 ]{1,11})$/m.test(value) ||
        !value ||
        "Sender ID is invalid",
    };

    function handleUpdate() {
      context.refs.settingForm.validate();
      if (formValid.value) {
        context.root.$mixpanel.track("Page Update", { Page: "Settings" });
        // Update settings
        const previousAutoTopUpEnabled =
          previousSettings.value.autoTopupSettings.autoTopupEnabled;
        const updatedAutoTopUpEnabled =
          settings.value.autoTopupSettings.autoTopupEnabled;
        const previousAutoTopUpSettings =
          previousSettings.value.autoTopupSettings;
        const updatedAutoTopUpSettings = settings.value.autoTopupSettings;

        const autoTopupSettingsCheck = _.isEqual(
          previousAutoTopUpSettings,
          updatedAutoTopUpSettings
        );
        const autoTopupEnabledCheck = _.isEqual(
          previousAutoTopUpEnabled,
          updatedAutoTopUpEnabled
        );

        const st = startTime.value.split(":");
        const startTimeHours = st[0];
        const startTimeMinutes = st[1];
        const et = endTime.value.split(":");
        const endTimeHours = et[0];
        const endTimeMinutes = et[1];
        const quietStartTime = {
          hours: parseInt(startTimeHours),
          minutes: parseInt(startTimeMinutes),
          seconds: 0,
          nanos: 0,
        };
        const quietEndTime = {
          hours: parseInt(endTimeHours),
          minutes: parseInt(endTimeMinutes),
          seconds: 0,
          nanos: 0,
        };

        const requestPayload = {
          quietStartTime,
          quietEndTime,
          smsSenderId: settings.value.smsSenderId,
          smartSendingDuration: settings.value.smartSendingDuration,
        };

        context.root.$store
          .dispatch("settings/updateSettings", requestPayload)
          .then((res) => {
            //
          })
          .catch((err) => {
            context.root.$mixpanel.track("Page Update Fail", {
              Page: "Settings",
            });
          });

        if (!autoTopupSettingsCheck || !autoTopupEnabledCheck) {
          context.root.$store
            .dispatch("settings/updateSettingsAutoTopUp", {
              autoTopupSettings: updatedAutoTopUpSettings,
              redirectUrl: `${context.root.$store.state.store.onlineShopUrl}admin/apps/${APP_NAME}`,
            })
            .then((res) => {
              if (res.confirmationUrl) {
                appBridge(context.root.$store.state.store).redirectTo(
                  res.confirmationUrl
                );
                context.root.$mixpanel.track("Enable Auto Topup", {
                  Page: "Settings",
                  Amount: updatedAutoTopUpSettings.autoTopupAmount.units,
                  Threshhold: updatedAutoTopUpSettings.autoTopupThreshold.units,
                  Budget:
                    updatedAutoTopUpSettings.autoTopupSettings.autoTopupBudget
                      .units,
                });
              }
              if (!updatedAutoTopUpSettings.autoTopupEnabled) {
                context.root.$mixpanel.track("Disable Auto Topup", {
                  Page: "Settings",
                });
              }
            })
            .catch((err) => {
              //
            });
        }
      }
    }

    onBeforeMount(() => {
      context.root.$mixpanel.track("Page Load", { Page: "Settings" });
      context.root.$store.dispatch("settings/getSettings").then((res) => {
        settings.value = res;
        previousSettings.value = _.cloneDeep(res);
        startTime.value =
          (res.quietStartTime.hours < 10
            ? `0${res.quietStartTime.hours}`
            : res.quietStartTime.hours) +
          ":" +
          (res.quietStartTime.minutes < 10
            ? `0${res.quietStartTime.minutes}`
            : res.quietStartTime.minutes);
        endTime.value =
          (res.quietEndTime.hours < 10
            ? `0${res.quietEndTime.hours}`
            : res.quietEndTime.hours) +
          ":" +
          (res.quietEndTime.minutes < 10
            ? `0${res.quietEndTime.minutes}`
            : res.quietEndTime.minutes);
      });
    });

    const loading = computed(() => context.root.$store.state.loading);
    function redirectTo(link) {
      appBridge(context.root.$store.state.store).redirectToRemote(link);
    }

    return {
      menu: false,
      menu2: false,
      redirectTo,
      loading,
      smartSendingOptions,
      settings,
      startTime,
      endTime,
      rules,
      validateQuietHours,
      formValid,
      handleUpdate,
    };
  },
});
